import React from 'react';
import styled from 'styled-components';
import { spacer4, spacer64, gray90, screenXxsMax } from '@spotify-internal/encore-foundation';
import { FormattedMessage, FormattedDate } from 'react-intl';

export function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterNav>
          <a href="https://www.spotify.com/legal/spotify-for-podcasters-platform-terms">
            <FormattedMessage
              id="navigation.terms-and-conditions"
              description="Link to the Terms and Conditions"
              defaultMessage="Terms &amp; Conditions"
            />
          </a>
          <a href="https://www.spotify.com/us/legal">
            <FormattedMessage
              id="navigation.legal"
              description="Link to Spotify's legal page"
              defaultMessage="Legal"
            />
          </a>
          <a href="https://www.spotify.com/legal/privacy-policy/">
            <FormattedMessage
              id="navigation.privacy"
              description="Link to Spotify's privacy page"
              defaultMessage="Privacy"
            />
          </a>
          <a href="https://www.spotify.com/legal/privacy-policy/#s13">
            <FormattedMessage
              id="navigation.cookies"
              description="Link to Spotify's cookie policy page"
              defaultMessage="Cookies"
            />
          </a>
        </FooterNav>
        <Copyright>
          © <FormattedDate value={new Date()} year="numeric" /> Spotify AB
        </Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  margin-top: auto;
`;

const FooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  margin-top: ${spacer64};
  padding: 24px 36px;
  border-top: 1px solid ${gray90};
  font-size: 12px;
  @media (max-width: ${screenXxsMax}) {
    align-items: flex-end;
  }
`;

const FooterNav = styled.nav`
  display: flex;
  > *:not(:last-child) {
    margin-right: 28px;
  }
  @media (max-width: ${screenXxsMax}) {
    flex-direction: column;
    a {
      padding: ${spacer4} 0;
    }
    a:last-child {
      padding-bottom: 0;
    }
  }
`;

const Copyright = styled.div`
  margin: 0;
  margin-left: auto;
  padding: 0;
`;
